module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Cooking-book-df29de4e55a6b4041fd2e7038cd4c1f3.svg";